import { combineReducers } from "redux";
import { Reducer as GeneralReducer } from "./States/General";
import { Reducer as AuthReducer } from "./States/Auth";
import { Reducer as SolutionReducer } from "./States/Solution";
import { Reducer as AgriSolutionReducer } from "./States/AgriSolution";
import { Reducer as ContactUsReducer } from "./States/ContactUs";
import { Reducer as SavedItemsReducer } from "./States/SavedItems";
import storage from "redux-persist/lib/storage";
import { CrfReducer } from "./States/CRF";
import CFPTableReducer from "./States/CFPTable";

const appReducer = combineReducers({
  general: GeneralReducer,
  auth: AuthReducer,
  solution: SolutionReducer,
  agriSolution: AgriSolutionReducer,
  SavedItemsReducer: SavedItemsReducer,
  contactUs: ContactUsReducer,
  crf: CrfReducer,
  cfpTable: CFPTableReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === "USER_LOGOUT") {
    storage.removeItem("persist:root");
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};
export default rootReducer;
